import { Http } from '../Api'

const activePromotion = 2

export default {
  async Participate (data = {}) {
    const Endpoint = Http.Endpoint.Promotion.Participate
    const Data = {
      Promotion: activePromotion,
      ...data,
    }
    return await Http.DoRequest(Endpoint, Data)
  },

  async Config (data = {}) {
    const Endpoint = Http.Endpoint.Promotion.Config
    const Data = {
      Promotion: activePromotion,
      ...data,
    }
    return await Http.DoRequest(Endpoint, Data)
  },
}
